// 实体
import Mx from "mxdraw";
import { handle_del } from "@/rlMxModules/operate/edit";
import store from "@/store/index";
import { delRlModules, getRlModules } from "@/mixins/LiteModuleDb.js";
import { generate_guid } from "@/rlMxModules/utils/util";
import { revokeRollback } from "@/rlMxModules/operate/revokeRollback.js";

class rlEntity extends Mx.MxDbEntity {
  constructor() {
    super();

    this.No_ = null;
    this.Guid = generate_guid();
    this.m_stdFlrGuid = store.state.globalData.rl_stdFlr_id; //标准层guid
    this.classTypeName = "rlEntity"; // 实体

    this.Color = new THREE.Color(0xffffff); //构件颜色
    this.m_groupName = ""; //分组名称
  }

  initData(obj) {
    this.m_stdFlrGuid = obj.m_stdFlrGuid;
    this.Guid = obj.Guid ? obj.Guid : this.Guid;
  }

  //用于撤销回退
  reDraw(obj) {
    this.m_stdFlrGuid = obj.m_stdFlrGuid;
    this.Guid = obj.Guid ? obj.Guid : this.Guid;
    this.Color = obj.Color;
  }

  // 删除
  erase() {
    delRlModules(
      this.classTypeName,
      store.state.globalData.rl_stdFlr_id,
      this.Guid
    );
    //
    if (
      !store.state.globalData.isReDo &&
      this.classTypeName != "rlText" &&
      this.classTypeName != "rlLine" &&
      this.classTypeName != "rlEntity" &&
      this.classTypeName != "rlCircle"
    ) {
      revokeRollback(this, store.state.globalData.drawStep, "delete");
    }
    // rlAppObj.rlMxDatabase.getGroup(this.m_groupName)?.delete(this);
    super.erase();
    this.setNeedUpdateDisplay();
  }
  async saveEditRevokeData() {
    if (
      !store.state.globalData.isReDo &&
      this.classTypeName != "rlText" &&
      this.classTypeName != "rlLine" &&
      this.classTypeName != "rlEntity" &&
      this.classTypeName != "rlCircle"
    ) {
      await revokeRollback(this, store.state.globalData.drawStep, "edit");
    }
  }

  // 返回图形源数据--用于数据存储
  getDataBase() {
    return {
      // ID: this.ID,
      // No_: this.No_,
      Guid: this.Guid,
      StdFlrGuid: store.state.globalData.rl_stdFlr_id,
    };
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    return {
      objID: this.objectId(),
      classTypeName: this.classTypeName,
      Color: this.Color,
    };
  }

  // 输出同理
  dwgOut(obj) {
    this.onDwgOut(obj);
    //obj.Guid = this.Guid
    obj.m_groupName = this.m_groupName;
    obj.m_stdFlrGuid = this.m_stdFlrGuid;
    return obj;
  }

  // 数据读入
  dwgIn(obj) {
    // 这里是公共的属性
    this.onDwgIn(obj);
    //this.initGuid(obj.Guid)
    this.m_stdFlrGuid = obj.m_stdFlrGuid;
    this.m_groupName = obj.m_groupName;
    return true;
  }
}

export default rlEntity;
